const siteConfig = {
  name: 'Easy Pairing: AI-Powered Group Matching & Team Formation',
  alt_name: 'Easy Pairing',
  description: 'AI-powered platform that helps organizations create optimal teams, match roommates, and build mentorship pairs using advanced compatibility matching.',
  url: process.env.NEXT_PUBLIC_DOMAIN || 'https://www.easypairing.com',
  ogImage: '/static/images/og-image.png',
  loading_bar_color: '#d97706', // Deep amber color to match new theme
  links: {  
    linkedin: 'https://www.linkedin.com/company/easypairing',
    twitter: 'https://twitter.com/easypairing',
    email: 'hello@easypairing.com'
  },
  seo_title: 'Easy Pairing | AI-Powered Group Matching & Team Formation Software',
  seo_description: 'Transform how you create teams with Easy Pairing\'s intelligent matching algorithm. Build optimal roommate pairs, mentorship connections, and high-performing teams using advanced AI. Free trial available.',
  seo_keywords: [
    'AI group matching',
    'team formation software',
    'roommate matching',
    'mentorship pairing',
    'compatibility matching',
    'student housing software',
    'team building platform',
    'group formation AI'
  ],
  ga4_measurement_id: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID,
  // Additional SEO settings
  twitter_handle: '@easypairing',
  locale: 'en_US',
  themeColor: '#d97706', // Deep amber theme color
};

export default siteConfig;
